import { appendPageNumber } from '~/features/shared/search/lib/appendPageNumber'

type GetTitle = (conditions: {
  shopType?: 'all' | 'apparel' | 'salon'
  brandName?: string
  searchWord?: string
  pageNumber?: number
}) => string

export const getTitle: GetTitle = ({
  shopType = 'all',
  brandName,
  searchWord,
  pageNumber = 1,
}) => {
  const shopText =
    shopType === 'salon'
      ? '美容室'
      : shopType === 'apparel'
        ? 'アパレルショップ'
        : `店舗`
  return appendPageNumber(
    `${searchWord ? `「${searchWord}」｜` : ''}${brandName ? `${brandName}を取り扱う` : ''}${shopText}一覧`,
    pageNumber
  )
}
